function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 283.5 269.2"
}, props), /*#__PURE__*/React.createElement("title", null, "VF_history_of_charge_session"), /*#__PURE__*/React.createElement("path", {
  d: "M117.4 212.4l16.8-58.4H88.3l77.8-97.2-16.8 58.4h45.9z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M141.8 0v28.3c33.9 0 62.2 8.9 81.7 25.7 21 18.1 31.4 45.2 31.4 80.6s-10.6 62.5-31.6 80.6c-19.5 16.8-47.8 25.6-81.7 25.6s-62.2-8.8-81.7-25.6c-21.1-18.1-31.7-45.2-31.7-80.6S38.9 72.1 59.9 54c1.3-1.2 2.8-2.3 4.2-3.4v41.3l28.4.1.1-91.9H0v28.3l46.5.1C18 50.4.1 85.3.1 134.6c0 92.7 63.5 134.6 141.7 134.6s141.7-41.9 141.7-134.6S220 0 141.8 0z"
})));